<script setup lang="ts">
import Logoimg from '/images/logos/iconadr.png';

const { mode } = useDevicePreview();
const brandName = computed(() => (mode.value === 'hp' ? 'JasaBayar' : 'JasaPembayaran'));
</script>
<template>
  <div class="logo" :class="{ 'logo--hp': mode === 'hp' }">
    <NuxtLink to="/" class="d-flex align-center ga-2 text-decoration-none logo__link">
      <img :src="Logoimg" alt="JasaPembayaran" class="logo-icon" />
      <span class="text-h5 font-weight-bold text-primary logo__name">{{ brandName }}</span>
    </NuxtLink>
  </div>
</template>

<style scoped>
.logo-icon {
  width: 34px;
  height: 34px;
  object-fit: contain;
  flex-shrink: 0;
}
.logo__link {
  min-width: 0;
  max-width: 100%;
}
.logo__name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.logo--hp .logo-icon {
  width: 28px;
  height: 28px;
}
.logo--hp .logo__name {
  font-size: 0.95rem !important;
  letter-spacing: -0.02em;
}
</style>
